import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7961ccbf"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7961ccbf&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7961ccbf')) {
      api.createRecord('7961ccbf', component.options)
    } else {
      api.reload('7961ccbf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7961ccbf", function () {
      api.rerender('7961ccbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/WeforsysText/index.vue"
export default component.exports